import React from 'react';
import './FrequentItemsTable.css';

const FrequentItemsTable = ({ items }) => {
  const formatCurrency = (amount) => {
    return `R ${parseFloat(amount).toFixed(1)}`;
  };

  if (!items || items.length === 0) {
    return (
      <div className="frequent-items-table">
        <div className="table-header">
          <h2>Frequently Bought Items</h2>
        </div>
        <div className="no-data">
          <div className="no-data-icon">🛒</div>
          <p>No transaction data available for the selected period.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="frequent-items-table">
      <div className="table-header">
        <h2>Frequently Bought Items</h2>
        <p className="table-subtitle">Items sorted by purchase frequency</p>
      </div>
      
      <div className="table-container">
        <table className="items-table">
          <thead>
            <tr>
              <th>Rank</th>
              <th>Item</th>
              <th>Times Purchased</th>
              <th>Total Quantity</th>
              <th>Total Spent</th>
              <th>Avg. Price</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item, index) => (
              <tr key={item.name || index} className={index < 3 ? `top-${index + 1}` : ''}>
                <td className="rank">
                  <span className="rank-number">#{index + 1}</span>
                  {index === 0 && <span className="trophy">🥇</span>}
                  {index === 1 && <span className="trophy">🥈</span>}
                  {index === 2 && <span className="trophy">🥉</span>}
                </td>
                <td className="item-name">
                  <span className="item-text">{item.name}</span>
                </td>
                <td className="frequency">
                  <span className="frequency-number">{item.frequency}</span>
                </td>
                <td className="quantity">
                  <span className="quantity-number">{item.totalQuantity}</span>
                </td>
                <td className="total-spent">
                  <span className="amount">{formatCurrency(item.totalSpent)}</span>
                </td>
                <td className="avg-price">
                  <span className="amount">{formatCurrency(item.averagePrice)}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      
      {items.length > 10 && (
        <div className="table-footer">
          <p>Showing top 10 most frequently purchased items</p>
        </div>
      )}
    </div>
  );
};

export default FrequentItemsTable;